// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infot {
  font-size: 1.4rem;
  text-align: left;
  color: #cc5f5f;
  font-weight: bold;
}

.infoh {
  text-align: left;
  font-size: 1.1rem;
}

.footer {
  padding-bottom: 0;
  margin-bottom: 0;
}

.imk {
  max-width: 800px;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/Help/Help.scss"],"names":[],"mappings":"AAIA;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,iBAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,mBAAA;AAHJ","sourcesContent":["@import '../../scss/colors.scss';\n@import '../../scss/globals';\n\n\n.infot{\n    font-size: 1.4rem;\n    text-align: left;\n    color: #cc5f5f;\n    font-weight:bold;\n}\n\n.infoh{\n    text-align: left;\n    font-size: 1.1rem;\n}\n\n.footer{\n    padding-bottom: 0;\n    margin-bottom: 0;\n}\n\n.imk{\n    max-width: 800px;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
